<div class="header-row px-[2rem] flex flex-row justify-between items-center" *ngIf="loading">
    <div class="left-side w-1/3">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '5rem'}"
        appearance="line"
        class="line"
      ></app-shimmer-loader>
    </div>
  </div>
<div class="journal-header-wrapper flex justify-between items-center" *ngIf="!loading">
    <div class="week-label-section flex items-center">
        <div class="icon-wrapper">
            <app-icon class="calender-icon" svgIcon="calender"></app-icon>
        </div>
        <div class="flex flex-col" *ngIf="weekNumber > 0; else groupNotStarted">
            <div class="flex items-center">
                <span class="week-heading-label font-poppins font-bold">
                    Week {{weekNumber}}
                </span>
                <span class="session-label" *ngIf="sessionDetails">
                  {{'S'+sessionDetails?.sessionNumber + ' ' + (sessionDetails?.sessionDate | date)}}
                </span>
            </div>
            <div class="selected-week-range-label font-work-sans font-normal" *ngIf="weekDetails?.startDate && weekDetails?.endDate">
                {{(weekDetails?.startDate | date) + ' - ' + (weekDetails?.endDate | date)}}
            </div>
        </div>
        <ng-template #groupNotStarted>
            <div class="flex flex-col">
                <span class="week-heading-label font-poppins font-bold">
                    Your group hasn't started yet.
                </span>
            </div>
        </ng-template>
    </div>
</div>
<div class="separator-section w-full">
    <hr class="separator">
</div>